import * as Actions from './actions';
import Reducer from './reducer';
import getMiddleware from './middleware';
import Component from './component';
import Container from './container';
import { Variant, Control } from './variant-components'; // Legacy API requires local abSDK (from nwApiSDK)
// be passed in and save the AB modules in a singleton

var api = function api(config) {
  return {
    Reducer: Reducer,
    Actions: Actions,
    Component: Component,
    Variant: Variant,
    Control: Control,
    Container: Container,
    Middleware: getMiddleware.bind(null, config.AbSDK)
  };
}; // API can import ab modules directly from the library.
// Binding to legacy object for backwards compatibility


api.Actions = Actions;
api.Reducer = Reducer;
api.Container = Container;
api.Variant = Variant;
api.Control = Control;
export { Actions, Reducer, Container, Variant, Control };
export default api;